module.exports = __webpack_public_path__ + "static/media/3-vouchers.3b371d4d.png";